/* global G */
/* eslint-disable no-unused-vars */
import { curry } from 'lib/util'
import concatQueryParams, { getEscaped } from 'app/_shared/events/search/query/util'

/**
 * Sets the current `query` term to search for tickets that have either
 * of the following conditions met:
 * - `requesterOrg` is the current org
 * - `requesterContactOr` is the current ref `organisation`
 * - `additionalParty` is the current org
 * - `itemInstalledAt` is the current org
 *
 * @param {Gaia.AppModule.Spec} module      app module
 * @param {Gaia.Component.Spec} component   action component
 * @param {Event|object} event              information about the event that triggered this handler
 * @returns {string}
 */
const ticketHasOrganisationOrPartyOrItem = (module, component, event) => {
  const orgId = getEscaped(module[G.MODEL][G.STATE][G.REF])

  const params = {
    type: 'metatype:ticket',
    and: 'AND (',
    requesterOrg: `requesterOrg:(${orgId})`,
    requesterContactOrg: `OR requesterContactOrg:(${orgId})`,
    additionalParty: `OR additionalParty:(${orgId})`,
    itemInstalledAt: `OR itemInstalledAt:(${orgId})`,
    end: ')',
  }

  return concatQueryParams(params)
}

export default curry(ticketHasOrganisationOrPartyOrItem)
